import React from 'react';
import { Layout } from '@/components/Layout';
import { Compass, TrendingUp, Zap, Target } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function Resources() {
  const sections = [
    {
      title: '全网教程聚合',
      icon: <Compass className="h-6 w-6" />,
      description: '覆盖自媒体、技术、设计、语言、考试、生活、职场等全领域教程资源',
      categories: [
        { name: '自媒体教程', link: '/category/self-media', color: 'bg-blue-500' },
        { name: '技术开发', link: '/category/tech', color: 'bg-green-500' },
        { name: '平面设计', link: '/category/design', color: 'bg-purple-500' },
        { name: '学习考试', link: '/category/study', color: 'bg-orange-500' },
        { name: '生活技能', link: '/category/life', color: 'bg-pink-500' },
        { name: '写作文案', link: '/category/writing', color: 'bg-yellow-500' },
      ]
    },
    {
      title: '全网工具聚合',
      icon: <Zap className="h-6 w-6" />,
      description: 'AI工具、剪辑软件、设计平台、办公效率、免费素材一站式聚合',
      categories: [
        { name: 'AI 工具', link: '/category/ai-tools', color: 'bg-cyan-500' },
        { name: '剪辑设计', link: '/category/editing', color: 'bg-indigo-500' },
        { name: '实用工具', link: '/category/tools', color: 'bg-teal-500' },
        { name: '优质网站', link: '/category/sites', color: 'bg-rose-500' },
      ]
    },
    {
      title: '运营与变现',
      icon: <TrendingUp className="h-6 w-6" />,
      description: '从流量运营到商业变现，助力创作者实现价值转化',
      categories: [
        { name: '运营涨粉', link: '/category/growth', color: 'bg-red-500' },
        { name: '变现干货', link: '/category/monetization', color: 'bg-amber-500' },
      ]
    },
    {
      title: 'AI 创作助手',
      icon: <Target className="h-6 w-6" />,
      description: 'AI对话问答、智能推荐、文生图创作，让AI成为你的创作伙伴',
      categories: [
        { name: 'AI 智能助手', link: '/', color: 'bg-violet-500', isAI: true },
        { name: 'AI 创意生成', link: '/ai-creator', color: 'bg-fuchsia-500' },
      ]
    },
  ];

  return (
    <Layout>
      <div className="container mx-auto px-4 md:px-6 py-12 max-w-6xl">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="bg-primary/10 p-4 rounded-2xl mb-4">
            <Compass className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight mb-4">资源导航</h1>
          <p className="text-muted-foreground text-lg max-w-xl">
            全场景资源聚合，一站式找到你需要的教程、工具与网站
          </p>
        </div>

        <div className="grid gap-8">
          {sections.map((section, idx) => (
            <div key={idx} className="bg-card border rounded-3xl p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-primary/10 p-3 rounded-2xl text-primary">
                  {section.icon}
                </div>
                <div>
                  <h2 className="text-2xl font-bold">{section.title}</h2>
                  <p className="text-sm text-muted-foreground">{section.description}</p>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mt-6">
                {section.categories.map((cat, catIdx) => (
                  <Link
                    key={catIdx}
                    to={cat.link}
                    className="group relative overflow-hidden rounded-2xl border hover:border-primary/50 transition-all hover:shadow-lg"
                  >
                    <div className="p-6 bg-gradient-to-br from-background to-muted/30">
                      <div className={`h-2 w-2 rounded-full ${cat.color} mb-3`} />
                      <h3 className="font-bold mb-1 group-hover:text-primary transition-colors">
                        {cat.name}
                      </h3>
                      {cat.isAI && (
                        <p className="text-xs text-muted-foreground">点击右下角按钮唤起</p>
                      )}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-primary/5 border border-primary/20 rounded-3xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">找不到想要的资源？</h3>
          <p className="text-muted-foreground mb-6">
            点击右下角 AI 助手，告诉我你的需求，我会为你智能推荐
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button asChild>
              <Link to="/submission">投稿资源</Link>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/contact">联系我们</Link>
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
